@if (toastService.toasts$ | async; as toasts) {
  @for (toast of toasts; track toast) {
    <kros-toast
      [toast]="toast"
      (remove)="remove($event)"
    ></kros-toast>
  }
}

@if (toastService.bottomRightToasts$ | async; as bottomRightToasts) {
  <div class="bottom-right-toasts">
    @for (toast of bottomRightToasts; track toast) {
      <kros-toast
        [toast]="toast"
        (remove)="remove($event)"
      ></kros-toast>
    }
  </div>
}
